__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/677591f/_next/";